import { render, staticRenderFns } from "./ProjectsHistoricalDataIndexPage.vue?vue&type=template&id=73927832&scoped=true&"
import script from "./ProjectsHistoricalDataIndexPage.vue?vue&type=script&lang=js&"
export * from "./ProjectsHistoricalDataIndexPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsHistoricalDataIndexPage.vue?vue&type=style&index=0&id=73927832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73927832",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73927832')) {
      api.createRecord('73927832', component.options)
    } else {
      api.reload('73927832', component.options)
    }
    module.hot.accept("./ProjectsHistoricalDataIndexPage.vue?vue&type=template&id=73927832&scoped=true&", function () {
      api.rerender('73927832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/HistoricalData/ProjectsHistoricalDataIndexPage.vue"
export default component.exports